import React from "react";
import { Col, Row, Button, Container, Card } from "react-bootstrap";
import Error from "../components/Error";
import Layout from "../components/layout";
import ServerProps from "../lib/serverProps";

import SubmitOfferForm from "../components/offers/SubmitOfferForm";

const Page = ({ state }) => {
  if (!state.user.id) {
    return <Error statusCode={401} />;
  }

  return (
    <Layout
      title="Stride Equity | Easily raise funds"
      meta={{
        card: "summary_large_image",
        description:
          "Easily raise funds while focusing on the growth of your company by simplifying the complex management of investments and investors.",
      }}
      hidefooter
      state={state}
    >
      <div className="funding">
        <Container className="content-wrapper standalone-pages">
          {/* <Row>
            <Col md={{ span: 6, offset: 3 }}>
              <h1 className="text-center">Fundraising with Stride Equity</h1>
              <p className="text-center airy">Easily raise funds while focusing on the growth of
                your company by simplifying the complex management of
                investments and investors.
              </p>
              <Card>
                <Card.Body>
                  <SubmitOfferForm />
                </Card.Body>
              </Card>
            </Col>
          </Row> */}
          <Row>
            <Col md={12}>
              <h2>Fundraising with Stride Equity</h2>
              <hr className="black-line" />
            </Col>
            <Col md={6}>
              <p className="">
                Easily raise funds <br /> while focusing on the <br /> growth of
                your company by simplifying <br /> the complex management of
                investments <br /> and investors.
              </p>
            </Col>
            <Col md={6}>
              <SubmitOfferForm />
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export async function getServerSideProps({ req, res }) {
  return {
    props: {
      state: await ServerProps.getState(req),
    },
  };
}

export default Page;
